import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
// import moment from 'moment-timezone';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import SearchButton from '../../components/atoms/SearchButton';
import MenuRegisterButton from '../../components/atoms/MenuRegisterButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';
import GochiKidUsedByAdminTable from '../organisms/GochiKidUsedByAdminTable';
import AdminUseGochiKidAdd from '../organisms/AdminUseGochiKidAdd';
import { getListGochiKidUsedByAdmin } from '../../actions/Gochis';

const styles = theme => ({
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  pageDiscriptionDiv: {
    paddingLeft: 26,
    paddingTop: 2,
    textAlign: 'left'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  buttonGroupLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  buttonGroupRight: {
    textAlign: 'right'
  },
  textInput100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      identityStatuses: state.identities.statuses,
      showHides: state.gochiMenus.showHide,
      menuChildTypes: state.gochiMenus.menuChildType,
      menuGenre: state.options.listMenuGenre,
      menuSituation: state.options.listMenuSituation,
      menuUserTarget: state.options.listMenuUserTarget
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          getListGochiKidUsedByAdmin
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openAdd', 'updateOpenAdd', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('userName', 'setUserName', ''),
  withState('shopName', 'setShopName', ''),
  withState('menuName', 'setMenuName', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('useDateFrom', 'setUseDateFrom', null),
  withState('useDateTo', 'setUseDateTo', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangePage: props => async (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }

      const searchKey = {
        displayName: props.userName,
        shopName: props.shopName,
        menuName: props.menuName,
        useDateFrom: props.useDateFrom,
        useDateTo: props.useDateTo,
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions
        .getListGochiKidUsedByAdmin(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        })
        .catch(() => {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.handleChangePage(
        null,
        this.props.page,
        this.props.rowsPerPage
      );
    }
  })
);

const Main = enhance(
  ({
    classes,
    handleChangePage,
    account,
    openDrawer,
    updateOpenDrawer,
    openTable,
    updateOpenTable,
    openAdd,
    updateOpenAdd,
    userName,
    setUserName,
    menuName,
    setMenuName,
    shopName,
    setShopName,
    useDateFrom,
    setUseDateFrom,
    useDateTo,
    setUseDateTo,
    loading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    page,
    setRowsPerPage
  }) => {
    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 100;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, limitNum);
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            こどもごちめし利用
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            <div>
              <TextField
                label="ユーザー名"
                placeholder="ユーザー名"
                type="search"
                className={classes.textField}
                margin="normal"
                value={userName}
                onChange={e => {
                  setUserName(e.target.value);
                }}
              />
              <TextField
                label="店舗名"
                placeholder="店舗名"
                type="search"
                className={classes.textField}
                margin="normal"
                value={shopName}
                onChange={e => {
                  setShopName(e.target.value);
                }}
              />
              <TextField
                InputLabelProps={{ shrink: true }}
                label="メニュー名"
                placeholder="メニュー名"
                type="search"
                className={classes.textField}
                margin="normal"
                value={menuName}
                onChange={e => {
                  setMenuName(e.target.value);
                }}
              />
              <TextField
                label="利用日(From)"
                type="date"
                className={classes.textField}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                value={useDateFrom}
                onChange={e => {
                  setUseDateFrom(e.target.value);
                }}
              />
              <TextField
                label="利用日(To)"
                type="date"
                className={classes.textField}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                value={useDateTo}
                onChange={e => {
                  setUseDateTo(e.target.value);
                }}
              />
            </div>
            <div className={classes.buttonGroupLeft}>
              <SearchButton onClickAction={searchAction} />
            </div>
            <div className={classes.buttonGroupRight}>
              <MenuRegisterButton
                onClickAction={() => {
                  updateOpenAdd(true);
                }}
                btnText="データ修正追加"
              />
            </div>
          </div>
          {openTable && (
            <GochiKidUsedByAdminTable
              handleChangePage={handleChangePage}
              selectedPage={page}
              setRowsPerPage={setRowsPerPage}
            />
          )}

          <div>
            <Modal open={openAdd}>
              <AdminUseGochiKidAdd
                updateOpenAdd={updateOpenAdd}
                handleChangePage={handleChangePage}
                page={page}
                limit={limitNum}
              />
            </Modal>
          </div>
          <ProgressDialog openProgress={openProgress} loading={loading} />
        </Paper>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
